<template>
  <main :class="{
  'three': isThreeInit,
  'backdrop': backdrop,
  [this.$i18n.locale]: true
}">
    <div id="mainbody">
      <MainHeader
          :backdrop="showMenu"
          :isFormSubmitted="formSubmitted"
          @toggleSmallPopup="handleSmallPopupOpened"
          @reset="resetWebSpecial"
      />
      <MultiStepForm
          v-show="!formSubmitted"
          @form-submitted="handleFormSubmitted"
          @sendCurrentStep="getCurrentStep"
      />
      <ThreeJSModel
          v-show="formSubmitted"
          :isVolumeMuted="volumeMuted"
          :isFormSubmitted="formSubmitted"
          :isSmallPopupOpened="smallPopupState"
          :formData="formData"
          :introClosed="overlayClosed"
          @toggleBackdrop="handleBackdrop"
          @toggleSmallPopup="handleSmallPopupOpened"
          @reset="resetWebSpecial"
      />
      <MainFooter
          @toggleSmallPopup="handleSmallPopupOpened"
          @volumeMuted="handleVolumeMuted"
          @closeOverlay="handleCloseOverlay"
          :currentStep="currentStep"
          :isFormSubmitted="formSubmitted"
      />
    </div>
  </main>
</template>

<script>
import MultiStepForm from "@/components/MultiStepForm.vue";
import ThreeJSModel from "@/components/ThreeJs/ThreeJSModel.vue";
import MainHeader from "@/components/layout/header/MainHeader.vue";
import MainFooter from "@/components/layout/footer/MainFooter.vue";

export default {
  components: {
    MultiStepForm,
    ThreeJSModel,
    MainHeader,
    MainFooter
  },
  data() {
    return {
      controlValue: '',
      showMultiStepForm: true,
      overlayClosed: false,
      backdrop: false,
      isThreeInit: false,
      showThreeJSModel: true,
      formSubmitted: false,
      currentStep: "Intro",
      smallPopupOpened: false,
      smallPopupStep: null,
      smallPopupState: null,
      volumeMuted: false,
      showMenu:null,
      formData: {}, // Hier speicherst du die Daten
    };
  },
  beforeMount() {
    this.getLanguage();
  },
  methods: {
    handleFormSubmitted(data) {
      this.formSubmitted = true; // Zustand aktualisieren, wenn das Formular abgesendet wird
      this.isThreeInit = true;
      this.formData = data; //
      this.currentStep = "";
    },
    handleCloseOverlay() {
      this.overlayClosed = true;
      // Alternativ könntest du hier auch ein Ereignis an Child2 senden, falls notwendig.
    },
    getCurrentStep(data) {
      this.currentStep = data
    },
    resetWebSpecial() {
      this.$cookies.remove('stepsData');
      window.location.reload();
    },
    handleBackdrop(data) {
      this.backdrop = data.backdrop;
      this.showMenu = data.showMenu;
    },
    handleVolumeMuted(data) {
      this.volumeMuted = data;
    },
    handleSmallPopupOpened(data) {
      this.smallPopupOpened = data.opened;
      this.smallPopupStep = data.step;
      this.smallPopupState = data;
    },
    getLanguage() {
      let storedLanguage = this.$cookies.get('language');

      if (storedLanguage) {
        // Wenn eine Sprache im Cookie gespeichert ist, verwenden wir diese.
        this.$i18n.locale = storedLanguage;
      } else {
        // Prüfen, ob ein GET-Parameter "lang" vorhanden ist
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
          // Wenn der GET-Parameter "lang" vorhanden ist, verwenden wir dessen Wert als Sprache
          this.$i18n.locale = langParam;
        } else if (window.location.pathname.includes('/de/')) {
          this.$i18n.locale = 'de';
        }else if (window.location.pathname.includes('/en/')) {
          this.$i18n.locale = 'en';
        }
        else if (window.location.pathname.includes('/tr/')) {
          this.$i18n.locale = 'tr';
        }
        else if (window.location.pathname.includes('/ja/')) {
          this.$i18n.locale = 'ja';
        }
        else if (window.location.pathname.includes('/cn/')) {
          this.$i18n.locale = 'cn';
        }
        else {
          // Wenn keine der obigen Bedingungen erfüllt ist, setzen wir die Sprache auf Deutsch
          this.$i18n.locale = 'de';
        }
      }
    }
  }
};
</script>

<style lang="scss">
main.three {
  position: relative;

  &.backdrop {
    &:after {
      content: "";
      position: absolute;
      left: 0px;
      top: 0px;
      width: 100%;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.6);
      z-index: 999;
    }

    .openmenu_wrapper {
      color: white;
    }
  }

}


</style>
